<!--生产打料图片列表-->
<template>
    <div class="punchImageList">
        <HeaderNav
            header-title="图片列表"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="form">
            <div class="image-wrapper">
                <van-uploader
                    v-model="fileList"
                    multiple
                    capture="camera"
                    max-count="10"
                    :max-size="20*1024*1024"
                    upload-text="拍照"
                    @click-upload="clickUpload"
                    :readonly="useCustomUpload"
                ></van-uploader>
            </div>
            <div class="txt-desc">
                <van-field
                    v-model="productRemark"
                    rows="3"
                    autosize
                    label=""
                    type="textarea"
                    maxlength="200"
                    placeholder="请输入备注"
                    show-word-limit
                ></van-field>
            </div>
        </div>
        <div class="btns">
            <van-button class="save-btn" type="primary" @click="saveData">
                保存
            </van-button>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import utils from '@/utils/util';
export default {
    name: 'punch-image-list',
    components: { HeaderNav },
    data() {
        return {
            frist_pcb_number: '',
            pcb_numbers: '',
            fileList: [],
            // 删除的文件列表
            delFiles: [],
            // 备注
            productRemark: '',
            // 文件ids
            fileIds: [],

            // 是否使用自定义上传  ios不用自定义 一直为false
            useCustomUpload: false,
        };
    },
    created() {
        // 如果不是苹果
        if (!/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            // 如果当前 安卓集成了 自定义上传
            if (window.JYExternalNative?.PhotoUpload) {
                this.useCustomUpload = true;
                window.callback_PhotoUpload = this.callback_PhotoUpload;
            }
        }
        this.pcb_numbers = this.$route.query.pcb_numbers;
        if (this.pcb_numbers.length > 0) {
            this.frist_pcb_number = this.pcb_numbers[0];
        }
        this.getInfo();
    },
    mounted() {
    },
    methods: {
        // 文件删除
        handleRemove(file) {
            let delIndex = null;
            const _that = this;
            for (const index in this.fileList) {
                if (file === this.fileList[index].id) {
                    delIndex = index;
                    break;
                }
            }
            if (delIndex !== null) {
                this.fileList.splice(delIndex, 1);
                if (file) {
                    this.$axios
                        .delete(this.GLOBAL.FILE_BASE_URL + 'file-manage/' + file)
                        .then(() => {
                            _that.$message({
                                message: '删除成功！',
                                type: 'success',
                            });
                        })
                        .catch(error => {
                            _that.$message.error(error.ErrorCode.Message);
                        });
                }
            }
        },
        // 获取详情 编辑时
        getInfo() {
            this.$axios.get('/interfaceApi/production/productpcb/scfhmx_picture?pcb_number=' + this.frist_pcb_number)
                .then(res => {
                    this.productRemark = res.product_remark;
                    if (res.product_files) {
                        const fileIds = res.product_files.split(',').filter(Boolean);
                        fileIds.forEach(fileId => {
                            this.loadFileDetail(fileId);
                        });
                    }
                });
        },
        // 获取文件下载预览地址（直接构建file-manage下载URL）
        loadFileDetail(fileId) {
            this.fileList.push({
                url: `${this.GLOBAL.FILE_BASE_URL}file-manage/${fileId}/download`,
                id: fileId,
                FileID: fileId,
                isImage: true,
                status: 'done',
            });
        },
        // 自定义原生上传  安卓
        clickUpload() {
            // 不用自定义上传 直接返回
            if (!this.useCustomUpload) {
                return;
            }
            const callMobileData = {
                albumSelection: false,
            };
            this.$callMobile('JYExternalNative', 'PhotoUpload', callMobileData);
        },
        // 原生拍照回调
        callback_PhotoUpload(data) {
            const name = new Date().getTime().toString();
            const base64Data = 'data:image/jpg;base64,' + data;
            const file = utils.base64ToFile(base64Data, name);
            this.fileList.push({
                content: base64Data,
                file: file,
                message: '',
                status: '',
            });
        },
        // 保存数据
        async saveData() {
            this.$toast.loading();
            try {
                await this.$axios.post('/interfaceApi/production/productpcb/product_files_upload', {
                    pcb_number: this.pcb_numbers,
                    productFiles: this.fileIds,
                    productRemark: this.productRemark,
                });
                this.$toast.clear();
                this.$toast.success('拍照保存成功');
                this.$router.isBack = 1;
                this.$router.back();
            } catch (e) {
                this.$toast.clear();
                if (e.ErrorCode) {
                    this.$toast(e.ErrorCode.Message);
                }
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.punchImageList
    padding-top 50rpx
    width 100%;
    background #f0f0f0
    .form
        height calc(100% - 68rpx)
        overflow-y auto
        >>> .van-uploader
            padding 0 20rpx
            .van-uploader__preview,.van-uploader__upload
                margin 10rpx 13rpx
            .van-image,.van-uploader__upload
                width 140rpx
                height 130rpx
        .txt-desc
            padding 20rpx
            .van-field
                border-radius 3rpx
    .btns
        position fixed
        left 0
        bottom 0
        padding 12rpx 0
        width 100%;
        display flex
        justify-content center
        background #f0f0f0
        .save-btn
            border-radius 8px
            padding 0 30rpx
</style>
